import React, { useEffect, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { cn, formatNumber } from '@/utils';
import { useRequest } from 'ahooks';
import { getCatalogOverview } from '@/service';
import { CatalogOverviewResponse } from '@/service/interface';
import { useRefreshData } from '@/hooks/useRefreshData';
import { useCatalogOverviewStore } from '@/state/catalog-store';
import { ChevRightFilledIcon, ChevRightIcon } from '@/components/Icons';
import { useDimensions } from '@/hooks/useDimensions';
import { useLeftPanelDrawer } from '@/state/drawer-store';

type NavKeyType = keyof NonNullable<CatalogOverviewResponse['data']>;

interface NavItem {
  to: string;
  name: string;
  key: NavKeyType;
  trackLen: number;
}

export const navList: NavItem[] = [
  {
    to: '/',
    name: 'All Tracks',
    key: 'all_tracks',
    trackLen: 0,
  },
  {
    to: '/published',
    name: 'Published',
    key: 'published_track',
    trackLen: 0,
  },
  {
    to: '/liked',
    name: 'Liked',
    key: 'liked_track',
    trackLen: 0,
  },
  {
    to: '/recent',
    name: 'Recent',
    key: 'recent_track',
    trackLen: 0,
  },
  {
    to: '/uncategorized',
    name: 'Uncategorized',
    key: 'uncategorised_track',
    trackLen: 0,
  },
  {
    to: '/archived',
    name: 'Archived',
    key: 'archived_track',
    trackLen: 0,
  },
];

export const linkNameMap = navList.reduce(
  (map, item) => {
    map[item.to] = item.name;
    return map;
  },
  {} as Record<string, string>,
);

const Catalog: React.FC = () => {
  const { refreshCatalogOverview } = useRefreshData();
  const { isMobileOrPad } = useDimensions();
  const { setIsDrawerShow } = useLeftPanelDrawer();
  const { catalogOverviewStore } = useCatalogOverviewStore();
  const NavListComposeTrackLen = useMemo<NavItem[]>(() => {
    return navList.map((nav) => {
      const trackLen = catalogOverviewStore[nav.key] || 0;
      return {
        ...nav,
        trackLen,
      };
    });
  }, [catalogOverviewStore]);

  useEffect(() => {
    refreshCatalogOverview();
  }, []);
  return (
    <div className="px-jen-spacing-8 catalog_box">
      <div className="text-jen-size-heading-07  mb-jen-spacing-8 text-jen-content-secondary">MY CATALOG</div>
      <nav className="flex flex-col ">
        {NavListComposeTrackLen.map(({ to, name, key, trackLen }) => {
          return (
            <NavLink
              to={to}
              key={key}
              className={({ isActive }) => (isActive ? 'text-jen-orange flex justify-between' : 'flex justify-between')}
              onClick={() => {
                if (isMobileOrPad) {
                  setIsDrawerShow(false);
                }
              }}
            >
              <TextWithNum subNameClassName=" top-[-16px]" className="flex-1 max-w-[230px]" name={name} num={trackLen} />
              <ChevRightFilledIcon className="lg:hidden" fillColor="currentColor" />
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Catalog;

interface TextWithNumProps {
  name: string;
  num: number;
  className?: string;
  subNameClassName?: string;
}

export const TextWithNum: React.FC<TextWithNumProps> = ({ name, num, className, subNameClassName }) => {
  return (
    <div className={cn('text-jen-size-heading-01 max-w-[170px] lg:max-w-[230px] truncate', className)}>
      <span className=" truncate">{name}</span>
      <span className={cn('text-[10px] relative top-[-5px] left-[4px]', subNameClassName)}>{formatNumber(num)}</span>
    </div>
  );
};
